import React from 'react';
import { useDispatch } from 'react-redux';
import SVG from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import classes from '../InCallParticipant.module.scss';
import { hooks } from '@lifesize/clients.sdk';
import micIcon from '@lifesize/ux-assets/vectors/svgIcons/mic.svg';
import micOffIcon from '@lifesize/ux-assets/vectors/svgIcons/mic-off.svg';
import _compact from 'lodash/compact';
import Tooltip from 'components/Tooltip/Tooltip';
import { callActions as nucleusCallActions } from '@lifesize/nucleus';

interface Props {
  participant: any;
}

export const getMicConfig = (participant, userIsModerator) => {
  const { localAudioMuteState, serverAudioMuteState } = participant;

  const config = {
    currentDataTestId: serverAudioMuteState || localAudioMuteState ? 'participantBtnMicOff' : 'participantBtnMicOn',
    currentIcon: serverAudioMuteState || localAudioMuteState ? micOffIcon : micIcon,
    currentIconClasses: _compact([
      classes.buttonIcon,
      userIsModerator && localAudioMuteState && !serverAudioMuteState ? classes.selfMuted : ''
    ]).join(' '),
    menuOptionDataTestId: '',
    menuOptionIcon: '',
    menuOptionLabel: <> </>
  };

  if (serverAudioMuteState) {
    config.menuOptionDataTestId = 'moreMenuOptionMicOn';
    config.menuOptionIcon = micIcon;
    config.menuOptionLabel = (
      <FormattedMessage
        id="components.inCall.participantDrawer.removeModeratorMute"
        defaultMessage="Remove moderator mute"
      />
    );
  } else {
    // !serverAudioMuteState
    config.menuOptionDataTestId = 'moreMenuOptionMicOff';
    config.menuOptionIcon = micOffIcon;
    config.menuOptionLabel = (
      <FormattedMessage id="components.inCall.participantDrawer.addModeratorMute" defaultMessage="Add moderator mute" />
    );
  }

  return config;
};

export const ParticipantMicButton = ({ participant }: Props) => {
  const userIsModerator = hooks.useIsCurrentUserModerator();
  const conferenceInfo = hooks.useConferenceInfo();
  const canBeMuted = userIsModerator && conferenceInfo?.state === 'escalated';
  const { isSelf } = participant;
  const dispatch = useDispatch();
  const micConfig = getMicConfig(participant, userIsModerator);
  const handleMuteParticipantClicked = (participant) => {
    dispatch(nucleusCallActions.muteParticipant(participant, !participant.serverAudioMuteState));
  };

  if (userIsModerator && canBeMuted && !isSelf) {
    return (
      <button
        className={classes.button}
        onClick={() => handleMuteParticipantClicked(participant)}
        data-testid={micConfig.currentDataTestId}
      >
        <SVG src={micConfig.currentIcon} className={micConfig.currentIconClasses} />
        <Tooltip
          fixPosition={true}
          label={micConfig.menuOptionLabel}
          location={'top'}
          overlapCarat={false}
          shift={'left'}
        />
      </button>
    );
  }

  // non-moderators just see an indicator
  return (
    <div className={`${classes.button} ${classes.noButton}`} data-testid={micConfig.currentDataTestId}>
      <SVG src={micConfig.currentIcon} className={micConfig.currentIconClasses} />
    </div>
  );
};

export default ParticipantMicButton;
